export const fetchSearchs = () => {
  return {
    method: 'GET',
    url: '/searchs'
  };
};
export const removeSearch = searchId => {
  return {
    method: 'DELETE',
    url: `/searchs/${searchId}`
  };
};
export const fetchSearch = searchId => {
  return {
    method: 'GET',
    url: `/searchs/${searchId}`
  };
};
export const updateSearch = (searchId, data) => {
  return {
    method: 'PUT',
    url: `/searchs/${searchId}`,
    data
  };
};
export const createSearch = data => {
  return {
    method: 'POST',
    url: '/searchs',
    data
  };
};
export const findByConditions = ({
  searchId
}) => {
  return {
    method: 'POST',
    url: '/metadata/search',
    data: {
      searchId
    }
  };
};
export const markMetadataInPdf = ({
  searchId,
  metadataId,
  url
}) => {
  return {
    method: 'POST',
    url: `/searchs/${searchId}/metadata/${metadataId}/mark`,
    data: {
      url
    }
  };
};
export const addDocument = ({
  searchId,
  ...data
}) => {
  return {
    method: 'POST',
    url: `/searchs/${searchId}/documents`,
    data
  };
};
export const updateDocument = ({
  searchId,
  documentId,
  ...data
}) => {
  return {
    method: 'PUT',
    url: `/searchs/${searchId}/documents/${documentId}`,
    data
  };
};
export const analyzeDocument = ({
  searchId,
  documentId,
  ...data
}) => {
  return {
    method: 'POST',
    url: `/searchs/${searchId}/documents/${documentId}/analyze`,
    data
  };
};
export const deleteDocument = ({
  searchId,
  documentId
}) => {
  return {
    method: 'DELETE',
    url: `/searchs/${searchId}/documents/${documentId}`
  };
};
export const createSuggestion = ({
  searchId,
  ...data
}) => {
  return {
    method: 'POST',
    url: `/searchs/${searchId}/suggestions`,
    data
  };
};
export const fetchSearchSuggestions = ({
  searchId,
  documentId
}) => {
  let queryString = '';

  if (documentId) {
    queryString = `documentId=${documentId}`;
  }

  return {
    method: 'GET',
    url: `/searchs/${searchId}/suggestions?${queryString}`
  };
};
export const deleteSearchSuggestion = ({
  searchId,
  suggestionId
}) => {
  return {
    method: 'DELETE',
    url: `/searchs/${searchId}/suggestions/${suggestionId}`
  };
};